import { DEFAULT_CANVAS_FONT_COLOR, DEFAULT_CANVAS_FONT_SIZE, fonts } from '@/constants';
import { ALIGNMENT, EDITABLE_TEXT_PROPERTIES, FONT_STYLE, FONT_WEIGHT } from '@/enums';
import { HexColor, TextStyleType } from '@/types';

export enum TEXT_STYLE_ACTIONS {
  SET_FONT_SIZE = 'SET_FONT_SIZE',
  SET_FONT_FAMILY = 'SET_FONT_FAMILY',
  SET_COLOR = 'SET_COLOR',
  SET_FONT_WEIGHT = 'SET_FONT_WEIGHT',
  SET_FONT_STYLE = 'SET_FONT_STYLE',
  SET_UNDERLINE = 'SET_UNDERLINE',
  SET_ALIGNMENT = 'SET_ALIGNMENT',
  SET_TEXT_VALUE = 'SET_TEXT_VALUE',
  SET_ALL_STYLES = 'SET_ALL_STYLES'
}

export const initialTextStyle: TextStyleType = {
  [EDITABLE_TEXT_PROPERTIES.FONT_SIZE]: DEFAULT_CANVAS_FONT_SIZE,
  [EDITABLE_TEXT_PROPERTIES.FONT_FAMILY]: fonts[0].value,
  [EDITABLE_TEXT_PROPERTIES.FILL]: DEFAULT_CANVAS_FONT_COLOR,
  [EDITABLE_TEXT_PROPERTIES.FONT_WEIGHT]: FONT_WEIGHT.NORMAL,
  [EDITABLE_TEXT_PROPERTIES.FONT_STYLE]: FONT_STYLE.NORMAL,
  [EDITABLE_TEXT_PROPERTIES.UNDERLINE]: false,
  [EDITABLE_TEXT_PROPERTIES.TEXT_ALIGN]: null,
  [EDITABLE_TEXT_PROPERTIES.TEXT]: ''
};

export type TextStyleActionType =
  | { type: TEXT_STYLE_ACTIONS.SET_FONT_SIZE; value: number }
  | { type: TEXT_STYLE_ACTIONS.SET_FONT_FAMILY; value: string }
  | { type: TEXT_STYLE_ACTIONS.SET_COLOR; value: HexColor }
  | { type: TEXT_STYLE_ACTIONS.SET_FONT_WEIGHT; value: FONT_WEIGHT }
  | { type: TEXT_STYLE_ACTIONS.SET_FONT_STYLE; value: FONT_STYLE }
  | { type: TEXT_STYLE_ACTIONS.SET_UNDERLINE; value: boolean }
  | { type: TEXT_STYLE_ACTIONS.SET_ALIGNMENT; value: ALIGNMENT }
  | { type: TEXT_STYLE_ACTIONS.SET_TEXT_VALUE; value: string }
  | { type: TEXT_STYLE_ACTIONS.SET_ALL_STYLES; value: Partial<TextStyleType> };

export const textStyleReducer = (
  state: TextStyleType,
  action: TextStyleActionType
): TextStyleType => {
  switch (action.type) {
    case TEXT_STYLE_ACTIONS.SET_FONT_SIZE:
      return { ...state, [EDITABLE_TEXT_PROPERTIES.FONT_SIZE]: action.value };
    case TEXT_STYLE_ACTIONS.SET_FONT_FAMILY:
      return { ...state, [EDITABLE_TEXT_PROPERTIES.FONT_FAMILY]: action.value };
    case TEXT_STYLE_ACTIONS.SET_COLOR:
      return { ...state, [EDITABLE_TEXT_PROPERTIES.FILL]: action.value };
    case TEXT_STYLE_ACTIONS.SET_FONT_WEIGHT:
      return { ...state, [EDITABLE_TEXT_PROPERTIES.FONT_WEIGHT]: action.value };
    case TEXT_STYLE_ACTIONS.SET_FONT_STYLE:
      return { ...state, [EDITABLE_TEXT_PROPERTIES.FONT_STYLE]: action.value };
    case TEXT_STYLE_ACTIONS.SET_UNDERLINE:
      return { ...state, [EDITABLE_TEXT_PROPERTIES.UNDERLINE]: action.value };
    case TEXT_STYLE_ACTIONS.SET_ALIGNMENT:
      return { ...state, [EDITABLE_TEXT_PROPERTIES.TEXT_ALIGN]: action.value };
    case TEXT_STYLE_ACTIONS.SET_TEXT_VALUE:
      return { ...state, [EDITABLE_TEXT_PROPERTIES.TEXT]: action.value };
    case TEXT_STYLE_ACTIONS.SET_ALL_STYLES:
      return { ...state, ...action.value };
    default:
      return state;
  }
};
